import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CompatClient, Stomp } from '@stomp/stompjs';
import * as SockJS from 'sockjs-client';
import { WebsocketListener } from 'src/app/core/models/websocket.model';

@Injectable({
  providedIn: 'root',
})
export class GroupSharingService {
  socketMessages: any = [];
  socketObservable = new BehaviorSubject({});
  joinFromInvite$ = new BehaviorSubject(null);
  meetingEndObservable = new BehaviorSubject(false);
  groupSharingActive = new BehaviorSubject(false);

  constructor(private http: HttpClient) { }
  private readonly socketListeners: Record<keyof typeof WebsocketListener | string, CompatClient> = {};
  generateToken(): Observable<any> {
    const url = environment.apiURL + `get-token`
    return this.http.get(url);
  }

  createMeeting(args): Observable<any> {
    const url = environment.apiURL + `create-meeting`
    return this.http.post(url, args);
  }

  validateMeeting(meetingId, args): Observable<any> {
    const url = environment.apiURL + `validate-meeting/${meetingId}`
    return this.http.post(url, args);
  }

  getTokenForOtherParticipants(): Observable<any> {
    const url = environment.apiURL + `get-token-ask-join`
    return this.http.get(url);
  }

  createCustomRoomId(options?: any): Observable<any> {
    const url = environment.apiURL + `api/watch-party`
    return this.http.post(url, options);
  }

  getHostToken(eventId: any, roomId: any): Observable<any> {
    const url = environment.apiURL + `api/watch-party/host-token?eventId=${eventId}&customRoomId=${roomId}`
    return this.http.get(url);
  }

  getEventDetails(eventId): Observable<any> {
    const url = environment.apiURL + `api/watch-party?eventId=${eventId}`
    return this.http.get(url);
  }

  getActiveWatchParty(eventId): Observable<any> {
    const url = environment.apiURL + `api/watch-party/active-parties?eventId=${eventId}`
    return this.http.get(url);
  }

  getParticipantToken(eventId, roomId): Observable<any> {
    const url = environment.apiURL + `api/watch-party/participant-token?eventId=${eventId}&customRoomId=${roomId}`
    return this.http.get(url);
  }

  addParticipantToExisitingEvent(params): Observable<any> {
    const url = environment.apiURL + `api/watch-party/participant`
    return this.http.post(url, params);
  }

  getPublicUsersList(str): Observable<any> {
    const url = environment.apiURL + `api/user-profile/search?term=${str}`;
    return this.http.get(url);
  }

  public addSocketListener(listenerKey: string, listener: CompatClient): void {
    this.socketListeners[listenerKey] = listener;
  }

  getUserProfileDetails(id): Observable<any> {
    const url = environment.apiURL + `api/user-profile/${id}`
    return this.http.get(url);
  }

  removeParticipants(obj): Observable<any> {


    const url = environment.apiURL + `api/watch-party/participant`
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: obj
    };
    return this.http.delete(url, options)
  }

  public subscribeToEventWatchParty(eventId: string): void {
    console.log('subscribtion')
    let listener = this.socketListeners[`${WebsocketListener.WATCH_PARTY}-${eventId}`];
    let watchPartyForUsers;

    if (!listener) {
      const watchPartyListener = Stomp.over(new SockJS(`${environment.apiURL}/web/messages`));
      this.addSocketListener(`${WebsocketListener.WATCH_PARTY}-${eventId}`, watchPartyListener);
      listener = this.socketListeners[`${WebsocketListener.WATCH_PARTY}-${eventId}`];
    }

    listener.connect({}, () => {
      listener.subscribe(`/watch-party/${eventId}`, (message) => {
        const watchPartyDetails = JSON.parse(message.body) as IWatchPartyDetails;

        let userDetails = JSON.parse(localStorage.getItem('userData'))
        console.log('watch-party')
        if (watchPartyDetails.messageType === 'WATCH_PARTY_PARTICIPANT_ADDED' && localStorage.getItem('userData')) {
          console.log('participantAdded')
          if (watchPartyDetails.userId === userDetails.userId) {
            // this.socketMessages.push(watchPartyDetails);
            this.socketObservable.next(watchPartyDetails)

          }
        }
        // if (watchPartyDetails.messageType === "WATCH_PARTY_PARTICIPANT_ADDED" && localStorage.getItem('userData')) {

        //   let item = watchPartyDetails.participants.substring(1)

        //   let finalVal = item.substring(0, item.length - 1).split(",")

        //   if (finalVal.filter((v) => v == userDetails.userId)) {
        //     this.socketMessages = watchPartyDetails;
        //     this.socketObservable.next(watchPartyForUsers)
        //   }
        // }
      });
    }, err => {

    });
  }

  updateEvent(obj, id): Observable<any> {
    const url = environment.apiURL + `api/watch-party/${id}`;
    return this.http.put(url, obj);
  }

  deleteEvent(customRoomId: any, eventId: any): Observable<any> {
    const url = environment.apiURL + `api/watch-party/${customRoomId}/${eventId}`;
    return this.http.delete(url);
  }

}

export interface IWatchPartyDetails {
  hostFirstName: string;
  customRoomId: string;
  partyType: WatchPartyType;
  eventId: string;
  messageType: string;
  participants: any;
  userId: string;
}

export enum WatchPartyType {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE'
}